import Debug from './debug'
import UsersOnline from './usersOnline'
import SMSBalance from './smsBalance/index'

const state = Object.assign({}, Debug.state, UsersOnline.state, SMSBalance.state)
const getters = Object.assign({}, Debug.getters, UsersOnline.getters, SMSBalance.getters)
const actions = Object.assign({}, Debug.actions, UsersOnline.actions, SMSBalance.actions)
const mutations = Object.assign({}, Debug.mutations, UsersOnline.mutations, SMSBalance.mutations)

export default {
  state,
  getters,
  mutations,
  actions
}
